import styled from 'astroturf/react';
import TextareaAutosize from 'react-textarea-autosize';
import Svg from 'src/components/Svg';

const EditDivButton = styled('button')`
  min-height: 36px;
  padding-left: 5px;
  width: 100%;
  background-color: white !important;

  &:focus {
    outline: none;
  }

  &.editable {
    &:hover {
      background-color: #f2f2f2 !important;
      cursor: pointer;
    }

    &:focus {
      background-color: #f2f2f2 !important;
    }
  }

  &.editingWithGreyBackground {
    background-color: #f2f2f2 !important;
  }

  &.vertical-center {
    display: flex;
    align-items: center;
  }

  &.border {
    border: 2px solid white;
    padding: 1px;
  }

  &.relative {
    position: relative;
  }

  &.isRequired {
    border: 2px solid red;
  }
`;

const EditDiv = styled('div')`
  min-height: 36px;
  padding: 0 5px;

  &.editable {
    &:hover {
      background-color: #f2f2f2;
      cursor: pointer;
    }
  }

  &.editingWithGreyBackground {
    background-color: #f2f2f2;
  }

  &.border {
    border: 2px solid white;
    padding: 1px;
  }

  &.relative {
    position: relative;
  }

  &.for-cap-text {
    display: block;
    width: 100%;
  }

  &.isRequired {
    border: 2px solid red;
  }
`;

const Button = styled('span')`
  width: 60px;
  height: 28px;
  border-radius: var(--ph-border-radius-sm);
  padding: 7px 13px;
  color: white;
  background-color: var(--ph-orange-500);

  &.cancel {
    background-color: #f2f2f2;
    background-image: none;
    color: black;
  }

  & + & {
    margin-left: 5px;
  }

  &:hover {
    cursor: pointer;
  }
`;

const PlaceHolderText = styled('div')`
  height: 36px;
  opacity: 0.3;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 1.94;
  letter-spacing: normal;
  color: var(--black);
  display: flex;
  align-items: center;
`;

const Row = styled('div')`
  display: block;
  width: 100%;
  white-space: nowrap;

  &.paddingForButtons {
    padding-top: 20px;
  }

  &.action-button-row {
    height: 34px;
    display: flex;
    align-items: center;
  }
`;

const TextField = styled('input')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 15px;
  letter-spacing: normal;
  color: var(--black);
  background-color: #f2f2f2;
  border: 2px solid var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  min-height: 42px;
  padding-left: 6px;

  &:focus {
    outline: none;
  }

  &.forTitle {
    overflow: hidden;
    font-size: var(--ph-text-sm);
    font-weight: 600;
    line-height: 1.44;
  }
`;

const TextAreaField = styled(TextareaAutosize)`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  color: var(--black);
  background-color: #f2f2f2;
  border: 2px solid var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  min-height: 42px;
  padding: 8px 5px 5px 8px;

  &:focus {
    outline: none;
  }
`;

const StatusSvg = styled(Svg)`
  width: 10px;
  fill: var(--white);
  margin-right: 4px;
  top: 1px;
  cursor: pointer;
`;

const ToggleSvg = styled(Svg)`
  width: 12px;
  fill: var(--white);
  top: 2px;

  &.collapsed {
    transform: rotate(-90deg);
  }
  cursor: pointer;
`;

const StatusSpan = styled('span')`
  height: 18px;
  font-size: var(--ph-text-sm);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--white);
  border-radius: var(--ph-border-radius-sm);
  padding: 12px 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.pending {
    background-color: #b8b8b8;
  }

  &.notRequired {
    background-color: #a9a9a9;
  }

  &.rejected {
    background-color: #db5034;
  }

  &.approved {
    background-color: #73b76a;
    top: 0;
  }

  &.pointer {
    cursor: pointer;
  }

  &.open {
    background-color: #b8b8b8;
  }

  &.closed {
    background-color: #73b76a;
    top: 0;
  }

  &.cap-overall-status-na {
    background-color: #b8b8b8;
  }

  &.cap-overall-status-pending {
    background-color: #b8b8b8;
  }

  /*
  keep width of the element containing largest text as max-content
   */
  &.cap-overall-status-needs-revision {
    background-color: #a9a9a9;
    width: max-content;
  }

  &.cap-overall-status-not-accepted {
    background-color: #db5034;
  }

  &.cap-overall-status-accepted {
    background-color: #73b76a;
    top: 0;
  }
`;

const StatusSwitchesBlock = styled('div')`
  font-size: var(--ph-text-xs);
  position: absolute;
  padding: 7px 0;
  border-radius: var(--ph-border-radius-sm);
  top: 37px;
  left: 0;

  &.open-to-close {
    right: 10px;
  }
  cursor: pointer;
  background: black;
`;

const StatusSwitchDiv = styled('div')`
  padding: 2px 7px;

  & + & {
    margin-top: 8px;
  }

  &:hover {
    cursor: pointer;
    background: grey;
  }
`;

const ActionTypeSpan = styled('span')`
  width: 120px;
  height: 20px;
  opacity: 0.6;
  border-radius: var(--ph-border-radius-sm);
  background-color: #e9d594;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.69;
  letter-spacing: normal;
  color: var(--black);
  padding: 3px;
  margin-left: 7px;

  &.preventiveAction {
    background-color: #8acbe6;
  }
`;

const RadioGroupInput = styled('input')`
  opacity: 0;
  position: absolute;
  z-index: -1;

  &:checked + [class*='RadioGroupCircle'] {
    border: solid 6px orange;
    border-color: var(--ph-orange-500);
  }
`;

const RadioGroupCircle = styled('div')`
  width: 16px;
  height: 16px;
  margin-right: 6px;
  border: 1px solid rgba(var(--ph-gray-rgb-500), 0.4);
  border-radius: 50%;
  background-color: var(--white);
`;

const RadioGroupText = styled('span')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--charcoal-grey);
`;

const RadioGroupItem = styled('label')`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 3px;
`;

const RadioGroupItemRow = styled('div')`
  display: inline-block;

  & + & {
    margin-left: 10px;
  }
`;

const ReviewNotesBox = styled('div')`
  padding: 5px 0;
  border-radius: var(--ph-border-radius-sm);
  background-color: #f5f5f5;
`;

const ReviewedDate = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--black);
  display: inline-block;
`;

const ReviewedBy = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--black);
  display: inline-block;
  margin-left: 30px;
`;

const ReviewNotesInfo = styled('div')`
  margin-top: 10px;
  padding: 0 10px;
`;

export default {
  EditDiv,
  EditDivButton,
  PlaceHolderText,
  Button,
  Row,
  TextField,
  TextAreaField,
  StatusSvg,
  StatusSpan,
  ToggleSvg,
  StatusSwitchesBlock,
  StatusSwitchDiv,
  ActionTypeSpan,
  RadioGroupInput,
  RadioGroupCircle,
  RadioGroupText,
  RadioGroupItem,
  RadioGroupItemRow,
  ReviewNotesBox,
  ReviewedDate,
  ReviewedBy,
  ReviewNotesInfo,
};
